<template>
	<div class="col-12 col-sm-6 col-lg-3">
		<label>Spells / Day</label>
		<div class="input-group" v-for="(number, spellLevel) in spellsPerDay" :key="`spells-day-${level}-${spellLevel}`">
			<div class="input-group-prepend">
				<span class="input-group-text">{{spellLevel | ordinal}}</span>
			</div>
			<input class="form-control" v-model.number="spellsPerDay[spellLevel]" />
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'level',
	],
	computed: {
		spellsPerDay: function() {
			return this.$store.state.Character.Levels[this.level].Spells.PerDay
		},
	},
	watch: {
		spellsPerDay: {
			deep: true,
			handler: function(value){
				this.$store.commit('setCharacterProp', [
					{
						key: `Levels[${this.level}].Spells.PerDay`,
						val: value,
					}
				])
			}
		}
	}
}
</script>

<style scoped>
.input-group-text {
	width: 3.75em;
}
</style>